import { Component, OnInit } from '@angular/core';
import { TranslocoService } from '@jsverse/transloco';
import { BehaviorSubject } from 'rxjs';

import { HeaderStateService } from '../../../main/headers/services/header-state.service';
import { SharedToasterService } from '../../../shared/services/shared-toaster.service';
import { AssignmentBillingPeriodModel } from '../../models/assignment-billing-period.model';
import { AssignmentsService } from '../../services/assignments.service';

@Component({
    templateUrl: './billed-assignments.component.html',
    styleUrl: './billed-assignments.component.scss'
})
export class BilledAssignmentsComponent implements OnInit {
    private readonly defaultYearsAmmount = 10;

    protected availableYears: number[] | null = null;
    protected selectedYear: number | null = null;
    protected assignmentBillingPeriodsSubject = new BehaviorSubject<AssignmentBillingPeriodModel[] | null>(null);

    constructor(
        private assignmentService: AssignmentsService,
        private headerStateService: HeaderStateService,
        private sharedToasterService: SharedToasterService,
        private translocoService: TranslocoService
    ) {
        this.headerStateService.setDetailHeader(
            this.translocoService.translate('main.header.billedAssignmentsTitle'),
            this.translocoService.translate('main.header.billedAssignmentsDescription'),
            '/assignments'
        );
    }

    ngOnInit(): void {
        this.setDefaultYears();

        if (this.selectedYear != null) {
            this.loadBilldedAssignmentsForYear(this.selectedYear)
        }
    }


    protected setFilteredYear(year: number) {
        this.selectedYear = year;
        this.loadBilldedAssignmentsForYear(year);
    }


    private setDefaultYears() {
        let currentYear = (new Date()).getFullYear();
        this.selectedYear = currentYear;

        const defaultYears: number[] = [];

        for (let index = 0; index < this.defaultYearsAmmount; index++) {
            defaultYears.push((currentYear - index))
        }

        this.availableYears = defaultYears;
    }


    private loadBilldedAssignmentsForYear(year: number): void {
        this.assignmentBillingPeriodsSubject.next(null);

        this.assignmentService.getAssignmentBillingPeriods(year)
            .subscribe({
                next: (response) => {

                    var periods = response.sort((a, b) => b.payoutMonthId - a.payoutMonthId);
                    this.assignmentBillingPeriodsSubject.next(periods);
                },
                error: (error) => {
                    this.sharedToasterService.showGeneralDataLoadingError();
                }
            });
    }
}
